import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';

class VisualComponent extends BasicComponent {
    getType() { return "VisualComponent"; }

    constructor( { id } = {} ) {
        super( { id });

        this.material = null;
        this.texture = null;
        this.mesh = null;
        this.scene = null;
        this.scaleFactor = 1;
    }

    setScaleFactor( value ){
        this.scaleFactor = value;
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab ).getRootNode();

        this.scene = window.scene;
       
        if(!prefab.getIconID())
            return undefined;
        
        this.texture = MediaManager.getMedia(prefab.getIconID());
        const name = "VisualComponentImage_"+prefab.getIconID();

        this.mesh = BABYLON.MeshBuilder.CreatePlane(name, { 
            width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
            height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
            sideOrientation: BABYLON.Mesh.DOUBLESIDE 
        }, window.scene);
        this.mesh.parent = base;

        this.material = new BABYLON.StandardMaterial(name + "_material", this.scene);
        this.material.emissiveTexture = this.texture.getTexture();
        this.material.emissiveTexture.uScale = -1;
        this.material.emissiveTexture.vScale = -1;
        this.material.disableLighting = true;   
        this.material.opacityTexture = this.texture.getTexture();
        this.material.opacityTexture.uScale = -1;
        this.material.opacityTexture.vScale = -1;
        this.material.emissiveTexture.hasAlpha = true;
        this.mesh.material = this.material;

        base.position = prefab.getPosition();

        if((prefab.getRotationX() && prefab.getRotationX() != 0) || (prefab.getRotationY() && prefab.getRotationY() != 0) || (prefab.getRotationZ() && prefab.getRotationZ() != 0)){
            base.rotation = new BABYLON.Vector3(prefab.getRotationX()* Math.PI / 180, prefab.getRotationY()* Math.PI / 180, prefab.getRotationZ()* Math.PI / 180);
        }else{
            base.lookAt(new BABYLON.Vector3(0,0,0));
        }
            
        return base;
    }
}

export default VisualComponent;

